export var createAddUnrenderedAudioWorkletNode = function createAddUnrenderedAudioWorkletNode(getUnrenderedAudioWorkletNodes) {
  return function (nativeContext, audioWorkletNode) {
    getUnrenderedAudioWorkletNodes(nativeContext).add(audioWorkletNode);
  };
};